import { getWhiteLabelLogo } from "@/api/white-label-logo";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { whiteLabelLogoKeys } from "./keys";
import logoStorage from "@/utils/white-label-logo-storage";

interface Props {
	logoPath: string | undefined;
}

export function getWhiteLabelLogoQueryOptions(logoPath: string) {
	return queryOptions({
		queryFn: async () => {
			const dataUrl = await getWhiteLabelLogo(logoPath);
			logoStorage.set(logoPath, dataUrl);
			return dataUrl;
		},
		queryKey: whiteLabelLogoKeys.whiteLabelLogo(logoPath),
		staleTime: Number.POSITIVE_INFINITY,
		retry: false,
		refetchOnWindowFocus: false,
	});
}

function useGetWhiteLabelLogo(props: Props) {
	const { logoPath } = props;

	const cachedLogo = logoPath ? logoStorage.get(logoPath) : "";

	const query = useQuery({
		...getWhiteLabelLogoQueryOptions(logoPath || ""),
		enabled: !!logoPath && !cachedLogo,
	});

	return {
		...query,
		data: cachedLogo || query.data || "",
	};
}

export default useGetWhiteLabelLogo;
